import { Box, styled, useMediaQuery, useTheme, IconButton } from '@mui/material';
import { ReactComponent as Logo } from 'assets/icons/Logo.svg';
import MenuIcon from '@mui/icons-material/Menu';
import { TooltipCC } from 'components/common';
import LanguageCC from 'components/Layout/LanguageCC';
import ProfileCC from 'components/Layout/ProfileCC';
import NotificationBox from 'components/NotificationBox';
import { useTranslation } from 'react-i18next';
import { goToLandingPage } from 'utils/functions';
import { HEIGHT_COMPONENTS } from 'constants/ui.contants';

const DEFAULT_BACKGROUND_IMAGE = 'linear-gradient(rgba(196, 19, 43, 1), rgba(238, 0, 51, 1))'

const AppBarWrapper = styled(Box)(({ theme }) => ({
    backgroundImage: DEFAULT_BACKGROUND_IMAGE,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: {
        xs: `0 16px`,
        sm: `0 26px`
    },
    height: HEIGHT_COMPONENTS.HEADER
}))

const AppBar = ({ onMenuClick }) => {
    const { t } = useTranslation()
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <AppBarWrapper sx={(theme) => ({ backgroundImage: `linear-gradient(${theme.palette.primary[1000]}, ${theme.palette.primary.dark})` })}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {isMobile && (
                    <TooltipCC title={t('menu')}>
                        <IconButton onClick={onMenuClick} sx={{ color: 'white' }}>
                            <MenuIcon />
                        </IconButton>
                    </TooltipCC>
                )}
                <TooltipCC title={t('goToLandingPage')}>
                    <Logo style={{ cursor: 'pointer', marginLeft: '16px' }} onClick={goToLandingPage} />
                </TooltipCC>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <div className="notification-container">
                    <NotificationBox />
                </div>
                <LanguageCC useContrast={true} />
                <ProfileCC />
            </Box>
        </AppBarWrapper>
    )
}

export default AppBar
